// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════════════════
   NETWATCH - REDISEÑO DE TABLAS SISTEMA
   ══════════════════════════════════════════════════════════════════════════════
   Reemplaza todas las secciones de tablas del CSS original.
   Funciona para TODOS los módulos: portafolio, cis, mantenimiento, config, etc.
   Solo cambia las clases relacionadas con tablas.
*/
.main-panel-portafolio {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.compact-content-portafolio {
  width: 94%;
  height: 93%;
  position: relative;
  background-color: transparent;
  display: block;
}

.content-card-portafolio {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-portafolio {
  position: relative;
  justify-content: center;
  display: block;
  height: 86%;
  width: 100%;
  /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
  /* border: 1px solid var(--border-table-color); */
  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);
}

.cont-portafolio-table {
  position: relative;
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

/* ═══════════════════════════════════════════════════════════════════
   IMPORTAR FUENTES
   ═══════════════════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════════════════
   HEADER DE TABLA (aplica a todos los módulos)
   ═══════════════════════════════════════════════════════════════════ */
.head-table-portafolio,
.head-table-portafolioDark,
.head-table-cis,
.head-table-cisDark,
.head-table-mantenimiento,
.head-table-mantenimientoDark,
.head-table-config,
.head-table-configDark {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  height: 10%;
  background: #0f2d5e !important;
  border-radius: 10px 10px 0 0;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.compact-head-table-portafolio {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  height: 100%;
  font-size: 11px;
}

.field-head-table-portafolio,
.field-head-table-cis,
.field-head-table-mantenimiento,
.field-head-table-config {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff !important;
  text-align: center;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.field-head-table-portafolio.field-nombre,
.field-head-table-portafolio.field-small,
.field-head-table-cis.field-nombre,
.field-head-table-cis.field-small,
.field-head-table-mantenimiento.field-nombre,
.field-head-table-mantenimiento.field-small {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.field-small {
  width: 5%;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.field-larger {
  width: 12%;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.field-medium {
  width: 7%;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

/* ═══════════════════════════════════════════════════════════════════
   BODY DE TABLA
   ═══════════════════════════════════════════════════════════════════ */
.body-table-portafolio,
.body-table-cis,
.body-table-mantenimiento,
.body-table-config {
  width: 100%;
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  height: 90%;
  overflow: auto;
  background: #ffffff;
}

/* Scroll personalizado */
.body-table-portafolio::-webkit-scrollbar,
.body-table-cis::-webkit-scrollbar,
.body-table-mantenimiento::-webkit-scrollbar {
  width: 6px;
}

.body-table-portafolio::-webkit-scrollbar-thumb,
.body-table-cis::-webkit-scrollbar-thumb,
.body-table-mantenimiento::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.body-table-portafolio::-webkit-scrollbar-thumb:hover,
.body-table-cis::-webkit-scrollbar-thumb:hover,
.body-table-mantenimiento::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ═══════════════════════════════════════════════════════════════════
   FILAS DE TABLA
   ═══════════════════════════════════════════════════════════════════ */
.row-table-portafolio,
.row-table-portafolioDark,
.row-table-cis,
.row-table-cisDark,
.row-table-mantenimiento,
.row-table-mantenimientoDark,
.row-table-config,
.row-table-configDark {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 50px;
  height: auto;
  color: #334155;
  background: #ffffff;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.12s ease;
  font-family: 'DM Sans', system-ui, sans-serif;
  cursor: pointer;
}

/* Dark mode */
.row-table-portafolioDark,
.row-table-cisDark,
.row-table-mantenimientoDark,
.row-table-configDark {
  color: #f1f5f9;
  background: #1e293b;
  border-bottom: 1px solid #334155;
}

.row-table-portafolio:hover,
.row-table-cis:hover,
.row-table-mantenimiento:hover,
.row-table-config:hover {
  background: #f8fafc !important;
}

.row-table-portafolioDark:hover,
.row-table-cisDark:hover,
.row-table-mantenimientoDark:hover,
.row-table-configDark:hover {
  background: #334155 !important;
}

/* ═══════════════════════════════════════════════════════════════════
   CELDAS DE TABLA
   ═══════════════════════════════════════════════════════════════════ */
.field-body-table-portafolio,
.field-body-table-cis,
.field-body-table-mantenimiento,
.field-body-table-config {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  word-wrap: anywhere;
  padding: 12px 8px;
  font-family: 'DM Sans', system-ui, sans-serif;
}

/* IDs y números en monospace */
.field-body-table-portafolio:first-child,
.field-body-table-cis:first-child,
.field-body-table-mantenimiento:first-child {
  font-family: 'DM Mono', monospace;
}

/* ═══════════════════════════════════════════════════════════════════
   CONTENEDORES
   ═══════════════════════════════════════════════════════════════════ */
.cont-table-portafolio,
.cont-table-cis,
.cont-table-mantenimiento,
.cont-table-config {
  width: 100%;
  height: 100%;
  border: 1px solid #e2e8f0;
  /* border-radius: 10px; */
  display: block;
  position: relative;
  overflow: hidden;
}

.cont-load-user-list {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.cont-row-user-list {
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* ═══════════════════════════════════════════════════════════════════
   ACCIONES (BOTONES EDITAR/ELIMINAR)
   ═══════════════════════════════════════════════════════════════════ */
.cont-img-field-acciones {
  position: relative;
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-field-acciones {
  position: relative;
  width: 18px;
  max-width: 18px;
  height: auto;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.12s ease;
}

.img-field-acciones:hover {
  opacity: 1;
}

.delteException {
  max-width: 18px;
}

.btnAction {
  cursor: pointer;
  transition: transform 0.12s ease;
}

.btnAction:hover {
  transform: scale(1.05);
}

/* ═══════════════════════════════════════════════════════════════════
   EMPTY STATE
   ═══════════════════════════════════════════════════════════════════ */
.no-results {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #94a3b8;
  font-size: 13px;
  font-family: 'DM Sans', system-ui, sans-serif;
}

/* ═══════════════════════════════════════════════════════════════════
   PAGINADOR
   ═══════════════════════════════════════════════════════════════════ */
.content-portafolio-footer,
.content-portafolio-footerDark,
.content-cis-footer,
.content-cisDark-footer {
  position: relative;
  justify-content: space-between;
  align-items: center;
  display: flex;
  height: 7%;
  width: 100%;
  border-radius: 0 0 10px 10px;
  border: 1px solid #e2e8f0;
  border-top: none;
  /* padding: 0 16px; */
  background: #ffffff;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.content-portafolio-footerDark,
.content-cisDark-footer {
  background: #1e293b;
  border-color: #334155;
}

.cont-display-paginador {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-left: 5%;
  padding-right: 5%;
}

.cont-half-display-paginador,
.cont-half-display-paginadorDark {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #64748b;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.cont-half-display-paginadorDark {
  color: #cbd5e1;
}

.pageSelector {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 12px;
  color: #334155;
  cursor: pointer;
  outline: none;
  font-family: 'DM Sans', system-ui, sans-serif;
  transition: background 0.12s ease;
}

.pageSelector:hover {
  background: #f8fafc;
}

/* ═══════════════════════════════════════════════════════════════════
   HEADER SECTION (BOTONES EXCEL, ETC)
   ═══════════════════════════════════════════════════════════════════ */
.content-portafolio-head,
.content-portafolio-headDark {
  position: relative;
  justify-content: space-between;
  align-items: center;
  display: flex;
  height: 5%;
  width: 100%;
  border-radius: 10px 10px 0 0;
  /* border: 1px solid #e2e8f0; */
  /* padding: 0 16px; */
  /* background: #ffffff; */
  font-family: 'DM Sans', system-ui, sans-serif;
}

.content-portafolio-headDark {
  background: #1e293b;
  border-color: #334155;
}

.cont-excels-buttons-portafolio {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  height: 100%;
}

.half-excels-buttons-portafolio {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.12s ease;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.half-excels-buttons-portafolio:hover {
  background: #f8fafc;
}

.top-half-excels-buttons-portafolio,
.top-half-excels-buttons-portafolioDark {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.top-half-excels-buttons-portafolioDark {
  color: #cbd5e1;
}

.body-half-excels-buttons-portafolio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-dwnld-portafolio {
  width: 16px;
  height: auto;
}

.img-dwnld-portafolio:hover {
  transform: scale(1.05);
}

/* ═══════════════════════════════════════════════════════════════════
   ESTADOS Y BADGES
   ═══════════════════════════════════════════════════════════════════ */
.txtCisCancelada,
.txtCisRechazada {
  font-weight: 600;
  color: #db2777;
}

.txtCisCerrada {
  font-weight: 600;
  color: #057a55;
}

.txtCisIniciada,
.txtCisIniciado {
  font-weight: 600;
  color: #d97706;
}

.txtCisNo {
  font-weight: 600;
  color: #0f172a;
}

.txtCisPendiente {
  color: #db2777;
}

/* ═══════════════════════════════════════════════════════════════════
   RESPONSIVE
   ═══════════════════════════════════════════════════════════════════ */
@media (min-width: 500px) and (max-width: 900px) {
  .cont-excels-buttons-portafolio {
    width: 25% !important;
    left: 75% !important;
  }

  .field-head-table-portafolio,
  .field-body-table-portafolio {
    font-size: 10px;
  }
}

@media (max-width: 500px) {
  .cont-excels-buttons-portafolio {
    width: 30% !important;
    left: 70% !important;
  }

  .cont-display-paginador {
    width: 40%;
  }

  .field-head-table-portafolio,
  .field-body-table-portafolio {
    font-size: 9px;
  }
}

/* ═══════════════════════════════════════════════════════════════════
   FIN DEL REDISEÑO
   ═══════════════════════════════════════════════════════════════════ */`, "",{"version":3,"sources":["webpack://./src/components/portafolio-components/styles/PanelPortafolio.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;AACD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,WAAW;EACX,2FAA2F;EAC3F,iDAAiD;EACjD,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;wEAEwE;;AAGxE;;wEAEwE;AACxE;;;;;;;;EAQE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;;;;;;EAME,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,gDAAgD;AAClD;;AAEA;;wEAEwE;AACxE;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;wEAEwE;AACxE;;;;;;;;EAQE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,6CAA6C;EAC7C,eAAe;AACjB;;AAEA,cAAc;AACd;;;;EAIE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;wEAEwE;AACxE;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA,+BAA+B;AAC/B;;;EAGE,iCAAiC;AACnC;;AAEA;;wEAEwE;AACxE;;;;EAIE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;;AAEA;;wEAEwE;AACxE;;;;EAIE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;wEAEwE;AACxE;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;wEAEwE;AACxE;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;wEAEwE;AACxE;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;;wEAEwE","sourcesContent":["/* ══════════════════════════════════════════════════════════════════════════════\r\n   NETWATCH - REDISEÑO DE TABLAS SISTEMA\r\n   ══════════════════════════════════════════════════════════════════════════════\r\n   Reemplaza todas las secciones de tablas del CSS original.\r\n   Funciona para TODOS los módulos: portafolio, cis, mantenimiento, config, etc.\r\n   Solo cambia las clases relacionadas con tablas.\r\n*/\r\n.main-panel-portafolio {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  background-color: transparent;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.compact-content-portafolio {\r\n  width: 94%;\r\n  height: 93%;\r\n  position: relative;\r\n  background-color: transparent;\r\n  display: block;\r\n}\r\n\r\n.content-card-portafolio {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.content-portafolio {\r\n  position: relative;\r\n  justify-content: center;\r\n  display: block;\r\n  height: 86%;\r\n  width: 100%;\r\n  /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\r\n  /* border: 1px solid var(--border-table-color); */\r\n  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);\r\n}\r\n\r\n.cont-portafolio-table {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   IMPORTAR FUENTES\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   HEADER DE TABLA (aplica a todos los módulos)\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.head-table-portafolio,\r\n.head-table-portafolioDark,\r\n.head-table-cis,\r\n.head-table-cisDark,\r\n.head-table-mantenimiento,\r\n.head-table-mantenimientoDark,\r\n.head-table-config,\r\n.head-table-configDark {\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  height: 10%;\r\n  background: #0f2d5e !important;\r\n  border-radius: 10px 10px 0 0;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.compact-head-table-portafolio {\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  height: 100%;\r\n  font-size: 11px;\r\n}\r\n\r\n.field-head-table-portafolio,\r\n.field-head-table-cis,\r\n.field-head-table-mantenimiento,\r\n.field-head-table-config {\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #ffffff !important;\r\n  text-align: center;\r\n  font-weight: 500;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.field-head-table-portafolio.field-nombre,\r\n.field-head-table-portafolio.field-small,\r\n.field-head-table-cis.field-nombre,\r\n.field-head-table-cis.field-small,\r\n.field-head-table-mantenimiento.field-nombre,\r\n.field-head-table-mantenimiento.field-small {\r\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.field-small {\r\n  width: 5%;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.field-larger {\r\n  width: 12%;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.field-medium {\r\n  width: 7%;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   BODY DE TABLA\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.body-table-portafolio,\r\n.body-table-cis,\r\n.body-table-mantenimiento,\r\n.body-table-config {\r\n  width: 100%;\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 90%;\r\n  overflow: auto;\r\n  background: #ffffff;\r\n}\r\n\r\n/* Scroll personalizado */\r\n.body-table-portafolio::-webkit-scrollbar,\r\n.body-table-cis::-webkit-scrollbar,\r\n.body-table-mantenimiento::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.body-table-portafolio::-webkit-scrollbar-thumb,\r\n.body-table-cis::-webkit-scrollbar-thumb,\r\n.body-table-mantenimiento::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.body-table-portafolio::-webkit-scrollbar-thumb:hover,\r\n.body-table-cis::-webkit-scrollbar-thumb:hover,\r\n.body-table-mantenimiento::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   FILAS DE TABLA\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.row-table-portafolio,\r\n.row-table-portafolioDark,\r\n.row-table-cis,\r\n.row-table-cisDark,\r\n.row-table-mantenimiento,\r\n.row-table-mantenimientoDark,\r\n.row-table-config,\r\n.row-table-configDark {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  min-height: 50px;\r\n  height: auto;\r\n  color: #334155;\r\n  background: #ffffff;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  transition: background 0.12s ease;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Dark mode */\r\n.row-table-portafolioDark,\r\n.row-table-cisDark,\r\n.row-table-mantenimientoDark,\r\n.row-table-configDark {\r\n  color: #f1f5f9;\r\n  background: #1e293b;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.row-table-portafolio:hover,\r\n.row-table-cis:hover,\r\n.row-table-mantenimiento:hover,\r\n.row-table-config:hover {\r\n  background: #f8fafc !important;\r\n}\r\n\r\n.row-table-portafolioDark:hover,\r\n.row-table-cisDark:hover,\r\n.row-table-mantenimientoDark:hover,\r\n.row-table-configDark:hover {\r\n  background: #334155 !important;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   CELDAS DE TABLA\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.field-body-table-portafolio,\r\n.field-body-table-cis,\r\n.field-body-table-mantenimiento,\r\n.field-body-table-config {\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  text-align: center;\r\n  word-wrap: anywhere;\r\n  padding: 12px 8px;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n/* IDs y números en monospace */\r\n.field-body-table-portafolio:first-child,\r\n.field-body-table-cis:first-child,\r\n.field-body-table-mantenimiento:first-child {\r\n  font-family: 'DM Mono', monospace;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   CONTENEDORES\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.cont-table-portafolio,\r\n.cont-table-cis,\r\n.cont-table-mantenimiento,\r\n.cont-table-config {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 1px solid #e2e8f0;\r\n  /* border-radius: 10px; */\r\n  display: block;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.cont-load-user-list {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.cont-row-user-list {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   ACCIONES (BOTONES EDITAR/ELIMINAR)\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.cont-img-field-acciones {\r\n  position: relative;\r\n  width: 50%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.img-field-acciones {\r\n  position: relative;\r\n  width: 18px;\r\n  max-width: 18px;\r\n  height: auto;\r\n  cursor: pointer;\r\n  opacity: 0.6;\r\n  transition: opacity 0.12s ease;\r\n}\r\n\r\n.img-field-acciones:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.delteException {\r\n  max-width: 18px;\r\n}\r\n\r\n.btnAction {\r\n  cursor: pointer;\r\n  transition: transform 0.12s ease;\r\n}\r\n\r\n.btnAction:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   EMPTY STATE\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.no-results {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #94a3b8;\r\n  font-size: 13px;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   PAGINADOR\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.content-portafolio-footer,\r\n.content-portafolio-footerDark,\r\n.content-cis-footer,\r\n.content-cisDark-footer {\r\n  position: relative;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  display: flex;\r\n  height: 7%;\r\n  width: 100%;\r\n  border-radius: 0 0 10px 10px;\r\n  border: 1px solid #e2e8f0;\r\n  border-top: none;\r\n  /* padding: 0 16px; */\r\n  background: #ffffff;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.content-portafolio-footerDark,\r\n.content-cisDark-footer {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n}\r\n\r\n.cont-display-paginador {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding-left: 5%;\r\n  padding-right: 5%;\r\n}\r\n\r\n.cont-half-display-paginador,\r\n.cont-half-display-paginadorDark {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.cont-half-display-paginadorDark {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.pageSelector {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  padding: 5px 8px;\r\n  font-size: 12px;\r\n  color: #334155;\r\n  cursor: pointer;\r\n  outline: none;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.pageSelector:hover {\r\n  background: #f8fafc;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   HEADER SECTION (BOTONES EXCEL, ETC)\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.content-portafolio-head,\r\n.content-portafolio-headDark {\r\n  position: relative;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  display: flex;\r\n  height: 5%;\r\n  width: 100%;\r\n  border-radius: 10px 10px 0 0;\r\n  /* border: 1px solid #e2e8f0; */\r\n  /* padding: 0 16px; */\r\n  /* background: #ffffff; */\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.content-portafolio-headDark {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n}\r\n\r\n.cont-excels-buttons-portafolio {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 12px;\r\n  height: 100%;\r\n}\r\n\r\n.half-excels-buttons-portafolio {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n  transition: background 0.12s ease;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.half-excels-buttons-portafolio:hover {\r\n  background: #f8fafc;\r\n}\r\n\r\n.top-half-excels-buttons-portafolio,\r\n.top-half-excels-buttons-portafolioDark {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n.top-half-excels-buttons-portafolioDark {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.body-half-excels-buttons-portafolio {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.img-dwnld-portafolio {\r\n  width: 16px;\r\n  height: auto;\r\n}\r\n\r\n.img-dwnld-portafolio:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   ESTADOS Y BADGES\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n.txtCisCancelada,\r\n.txtCisRechazada {\r\n  font-weight: 600;\r\n  color: #db2777;\r\n}\r\n\r\n.txtCisCerrada {\r\n  font-weight: 600;\r\n  color: #057a55;\r\n}\r\n\r\n.txtCisIniciada,\r\n.txtCisIniciado {\r\n  font-weight: 600;\r\n  color: #d97706;\r\n}\r\n\r\n.txtCisNo {\r\n  font-weight: 600;\r\n  color: #0f172a;\r\n}\r\n\r\n.txtCisPendiente {\r\n  color: #db2777;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   RESPONSIVE\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n  .cont-excels-buttons-portafolio {\r\n    width: 25% !important;\r\n    left: 75% !important;\r\n  }\r\n\r\n  .field-head-table-portafolio,\r\n  .field-body-table-portafolio {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .cont-excels-buttons-portafolio {\r\n    width: 30% !important;\r\n    left: 70% !important;\r\n  }\r\n\r\n  .cont-display-paginador {\r\n    width: 40%;\r\n  }\r\n\r\n  .field-head-table-portafolio,\r\n  .field-body-table-portafolio {\r\n    font-size: 9px;\r\n  }\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   FIN DEL REDISEÑO\r\n   ═══════════════════════════════════════════════════════════════════ */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
